import React, { useCallback, useState, createContext, useContext } from 'react';
type Language = 'en' | 'cs';
interface Translations {
  [key: string]: {
    en: string;
    cs: string;
  };
}
const translations: Translations = {
  // Navigation
  'nav.vehicles': {
    en: 'Vehicles',
    cs: 'Vozy'
  },
  'nav.about': {
    en: 'About',
    cs: 'O nás'
  },
  'nav.services': {
    en: 'Services',
    cs: 'Služby'
  },
  'nav.contact': {
    en: 'Contact',
    cs: 'Kontakt'
  },
  'nav.contactBtn': {
    en: 'Contact us',
    cs: 'Kontaktovat'
  },
  // Hero
  'hero.headline1': {
    en: 'Exceptional cars',
    cs: 'Výjimečné vozy'
  },
  'hero.headline2': {
    en: 'for exceptional drivers',
    cs: 'pro výjimečné řidiče'
  },
  'hero.subtitle': {
    en: 'We specialize in premium Porsche vehicles with a focus on quality and individual approach.',
    cs: 'Specializujeme se na prémiové vozy Porsche s důrazem na kvalitu a individuální přístup.'
  },
  'hero.cta': {
    en: 'View vehicles',
    cs: 'Prohlédnout vozy'
  },
  // Vehicles
  'vehicles.sectionLabel': {
    en: 'Current offer',
    cs: 'Aktuální nabídka'
  },
  'vehicles.sectionTitle': {
    en: 'Our vehicles',
    cs: 'Naše nabídka'
  },
  'vehicles.moreInfo': {
    en: 'More information',
    cs: 'Více informací'
  },
  'vehicles.price': {
    en: 'Price',
    cs: 'Cena'
  },
  'vehicles.year': {
    en: 'Year',
    cs: 'Rok'
  },
  'vehicles.mileage': {
    en: 'Mileage',
    cs: 'Nájezd'
  },
  'vehicles.color': {
    en: 'Color',
    cs: 'Barva'
  },
  'vehicles.viewDetail': {
    en: 'View details',
    cs: 'Zobrazit detail'
  },
  'vehicles.backToHome': {
    en: '← Back to home',
    cs: '← Zpět na úvod'
  },
  // Vehicle Detail
  'vehicleDetail.vin': {
    en: 'VIN',
    cs: 'VIN'
  },
  'vehicleDetail.yearOfConstruction': {
    en: 'Year of construction',
    cs: 'Rok výroby'
  },
  'vehicleDetail.initialReg': {
    en: 'Initial reg. date',
    cs: 'První registrace'
  },
  'vehicleDetail.model': {
    en: 'Model',
    cs: 'Model'
  },
  'vehicleDetail.body': {
    en: 'Body',
    cs: 'Karoserie'
  },
  'vehicleDetail.mileage': {
    en: 'Mileage',
    cs: 'Nájezd'
  },
  'vehicleDetail.power': {
    en: 'Power',
    cs: 'Výkon'
  },
  'vehicleDetail.transmission': {
    en: 'Transmission',
    cs: 'Převodovka'
  },
  'vehicleDetail.drive': {
    en: 'Drive',
    cs: 'Pohon'
  },
  'vehicleDetail.price': {
    en: 'Price',
    cs: 'Cena'
  },
  'vehicleDetail.inclVat': {
    en: 'incl. VAT',
    cs: 'vč. DPH'
  },
  'vehicleDetail.contactAbout': {
    en: 'Contact us about this vehicle',
    cs: 'Kontaktujte nás ohledně tohoto vozu'
  },
  'vehicleDetail.photoGallery': {
    en: 'Photo gallery',
    cs: 'Fotogalerie'
  },
  'vehicleDetail.specifications': {
    en: 'Specifications',
    cs: 'Specifikace'
  },
  'vehicleDetail.photosComingSoon': {
    en: 'Photos coming soon',
    cs: 'Fotografie již brzy'
  },
  'vehicleDetail.engineType': {
    en: 'Engine',
    cs: 'Motor'
  },
  'vehicleDetail.displacement': {
    en: 'Displacement',
    cs: 'Zdvihový objem'
  },
  'vehicleDetail.torque': {
    en: 'Torque',
    cs: 'Točivý moment'
  },
  'vehicleDetail.acceleration': {
    en: 'Acceleration',
    cs: 'Zrychlení'
  },
  'vehicleDetail.topSpeed': {
    en: 'Top speed',
    cs: 'Max. rychlost'
  },
  'vehicleDetail.weight': {
    en: 'Kerb weight',
    cs: 'Pohotovostní hmotnost'
  },
  'vehicleDetail.wheels': {
    en: 'Wheels',
    cs: 'Kola'
  },
  'vehicleDetail.brakes': {
    en: 'Brakes',
    cs: 'Brzdy'
  },
  // About
  'about.sectionLabel': {
    en: 'About us',
    cs: 'O nás'
  },
  'about.title': {
    en: 'Why Porsche Top?',
    cs: 'Proč Porsche Top?'
  },
  'about.description': {
    en: 'We are specialists in premium Porsche vehicles. We carefully select and verify each car to offer you only the best. Our individual approach and years of experience guarantee your satisfaction.',
    cs: 'Jsme specialisté na prémiové vozy Porsche. Každý vůz pečlivě vybíráme a prověřujeme, abychom vám mohli nabídnout jen to nejlepší. Náš individuální přístup a dlouholeté zkušenosti jsou zárukou vaší spokojenosti.'
  },
  'about.description2': {
    en: "We believe that buying a Porsche should be an exceptional experience. That's why we strive to provide every client with maximum service and support throughout the entire selection and purchase process.",
    cs: 'Věříme, že nákup Porsche by měl být výjimečným zážitkem. Proto se snažíme každému klientovi poskytnout maximální servis a podporu během celého procesu výběru a nákupu vozu.'
  },
  'about.feature1Title': {
    en: 'Verified vehicles',
    cs: 'Prověřené vozy'
  },
  'about.feature1Desc': {
    en: 'We thoroughly verify each vehicle and check its history.',
    cs: 'Každý vůz důkladně prověřujeme a kontrolujeme jeho historii.'
  },
  'about.feature2Title': {
    en: 'Premium quality',
    cs: 'Prémiová kvalita'
  },
  'about.feature2Desc': {
    en: 'We only offer vehicles in perfect technical and visual condition.',
    cs: 'Nabízíme pouze vozy v perfektním technickém i vizuálním stavu.'
  },
  'about.feature3Title': {
    en: 'Individual approach',
    cs: 'Individuální přístup'
  },
  'about.feature3Desc': {
    en: 'We approach each client individually according to their needs.',
    cs: 'Ke každému klientovi přistupujeme individuálně dle jeho potřeb.'
  },
  'about.feature4Title': {
    en: 'Years of experience',
    cs: 'Dlouholeté zkušenosti'
  },
  'about.feature4Desc': {
    en: 'We have extensive experience in selling premium Porsche vehicles.',
    cs: 'Máme bohaté zkušenosti s prodejem prémiových vozů Porsche.'
  },
  // Services
  'services.sectionLabel': {
    en: 'What we offer',
    cs: 'Co nabízíme'
  },
  'services.title': {
    en: 'Our services',
    cs: 'Naše služby'
  },
  'services.subtitle': {
    en: 'We provide comprehensive services related to the purchase and ownership of premium Porsche vehicles.',
    cs: 'Poskytujeme komplexní služby spojené s nákupem a vlastnictvím prémiových vozů Porsche.'
  },
  'services.service1Title': {
    en: 'Premium vehicle sales',
    cs: 'Prodej prémiových vozů'
  },
  'services.service1Desc': {
    en: 'We offer carefully selected Porsche vehicles in perfect condition.',
    cs: 'Nabízíme pečlivě vybrané vozy Porsche v perfektním stavu.'
  },
  'services.service2Title': {
    en: 'Purchase consulting',
    cs: 'Poradenství při výběru'
  },
  'services.service2Desc': {
    en: 'We will help you choose a car exactly according to your ideas and needs.',
    cs: 'Pomůžeme vám vybrat vůz přesně podle vašich představ a potřeb.'
  },
  'services.service3Title': {
    en: 'Financing & leasing',
    cs: 'Financování a leasing'
  },
  'services.service3Desc': {
    en: 'We will arrange favorable financing or leasing for your new car.',
    cs: 'Zajistíme výhodné financování nebo leasing vašeho nového vozu.'
  },
  'services.service4Title': {
    en: 'Vehicle insurance',
    cs: 'Pojištění vozidel'
  },
  'services.service4Desc': {
    en: 'We offer comprehensive insurance tailored for your Porsche.',
    cs: 'Nabízíme komplexní pojištění šité na míru pro váš Porsche.'
  },
  'services.service5Title': {
    en: 'Vehicle history check',
    cs: 'Prověření historie vozu'
  },
  'services.service5Desc': {
    en: 'We thoroughly check the history and technical condition of each vehicle.',
    cs: 'Důkladně prověříme historii a technický stav každého vozu.'
  },
  'services.service6Title': {
    en: 'Import on request',
    cs: 'Dovoz na přání'
  },
  'services.service6Desc': {
    en: 'We will import your dream car from abroad according to your requirements.',
    cs: 'Dovezeme vám vysněný vůz ze zahraničí dle vašich požadavků.'
  },
  // Contact
  'contact.sectionLabel': {
    en: 'Get in touch',
    cs: 'Spojte se s námi'
  },
  'contact.title': {
    en: 'Contact us',
    cs: 'Kontaktujte nás'
  },
  'contact.subtitle': {
    en: "Interested in one of our vehicles or need advice? Don't hesitate to contact us.",
    cs: 'Máte zájem o některý z našich vozů nebo potřebujete poradit? Neváhejte nás kontaktovat.'
  },
  'contact.phone': {
    en: 'Phone',
    cs: 'Telefon'
  },
  'contact.email': {
    en: 'E-mail',
    cs: 'E-mail'
  },
  'contact.address': {
    en: 'Address',
    cs: 'Adresa'
  },
  'contact.addressValue': {
    en: 'Prague, Czech Republic',
    cs: 'Praha, Česká republika'
  },
  'contact.formName': {
    en: 'Full name',
    cs: 'Jméno a příjmení'
  },
  'contact.formNamePlaceholder': {
    en: 'John Smith',
    cs: 'Jan Novák'
  },
  'contact.formEmail': {
    en: 'E-mail',
    cs: 'E-mail'
  },
  'contact.formEmailPlaceholder': {
    en: 'john@email.com',
    cs: 'jan@email.cz'
  },
  'contact.formPhone': {
    en: 'Phone',
    cs: 'Telefon'
  },
  'contact.formPhonePlaceholder': {
    en: '+420 123 456 789',
    cs: '+420 123 456 789'
  },
  'contact.formMessage': {
    en: 'Message',
    cs: 'Zpráva'
  },
  'contact.formMessagePlaceholder': {
    en: 'Your message...',
    cs: 'Vaše zpráva...'
  },
  'contact.formSubmit': {
    en: 'Send message',
    cs: 'Odeslat zprávu'
  },
  'contact.formSent': {
    en: 'Message sent successfully!',
    cs: 'Zpráva byla úspěšně odeslána!'
  },
  'contact.formSending': {
    en: 'Sending...',
    cs: 'Odesílání...'
  },
  'contact.formError': {
    en: 'Failed to send. Please try again.',
    cs: 'Odeslání se nezdařilo. Zkuste to prosím znovu.'
  },
  'contact.formSubject': {
    en: 'Inquiry from porschetop.cz',
    cs: 'Dotaz z porschetop.cz'
  },
  // Footer
  'footer.description': {
    en: 'We specialize in premium Porsche vehicles. We offer carefully selected cars with a focus on quality and individual approach to each client.',
    cs: 'Specializujeme se na prémiové vozy Porsche. Nabízíme pečlivě vybrané vozy s důrazem na kvalitu a individuální přístup ke každému klientovi.'
  },
  'footer.quickLinks': {
    en: 'Quick links',
    cs: 'Rychlé odkazy'
  },
  'footer.contactTitle': {
    en: 'Contact',
    cs: 'Kontakt'
  },
  'footer.copyright': {
    en: '© 2026 Porsche Top. All rights reserved.',
    cs: '© 2026 Porsche Top. Všechna práva vyhrazena.'
  },
  'footer.madeWith': {
    en: 'Made with ❤️ for Porsche enthusiasts',
    cs: 'Vytvořeno s ❤️ pro milovníky Porsche'
  }
};
interface LanguageContextType {
  lang: Language;
  setLang: (lang: Language) => void;
  t: (key: string) => string;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
interface LanguageProviderProps {
  children: ReactNode;
}
export function LanguageProvider({
  children
}: LanguageProviderProps) {
  const [lang, setLang] = useState<Language>('en');
  const t = useCallback((key: string): string => {
    const translation = translations[key];
    if (!translation) {
      console.warn(`Missing translation for key: ${key}`);
      return key;
    }
    return translation[lang];
  }, [lang]);
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-262">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}